export const joinClassNames = (...classNames) => {
  return classNames.filter(item => item).join(" ");
}
